import React, { useEffect } from "react";
import { useURLParamsSetter } from "~/hooks/useURLParamsSetter";
import Modal from "~/shared/ui/Fields/Modal";
import { useForm } from "react-hook-form";
import s from "./HistoryActsFilter.less";
import {
  defaultValueActsFilter,
  defaultValueActsFilterIProps,
} from "./options";
import HistoryActsForm from "./HistoryActsForm";

export interface HistoryActsFilterIProps {
  openModal?: string;
  initialValues: defaultValueActsFilterIProps;
  getIvideonHistoryActs: (data: defaultValueActsFilterIProps) => void;
}

const HistoryActsFilter = ({
  openModal,
  initialValues,
  getIvideonHistoryActs,
}: HistoryActsFilterIProps) => {
  const setURLParams = useURLParamsSetter();
  const { handleSubmit, control, reset } =
    useForm<defaultValueActsFilterIProps>({
      defaultValues: initialValues,
    });

  const closeModal = () => {
    setURLParams({ openModal: "" });
  };

  useEffect(() => {
    reset(initialValues);
  }, [initialValues, reset]);

  const submit = (data: defaultValueActsFilterIProps) => {
    getIvideonHistoryActs(data);
    closeModal();
  };
  const resetFilter = () => {
    reset(defaultValueActsFilter);
  };
  return (
    <Modal
      customClassName={s.modalStyle}
      isOpen={!!openModal}
      title="Фильтры"
      withCloseBtn={false}
      actionClose={closeModal}
    >
      {openModal && (
        <HistoryActsForm
          closeModal={closeModal}
          control={control}
          onSubmit={handleSubmit(submit)}
          resetFilter={resetFilter}
        />
      )}
    </Modal>
  );
};
export default HistoryActsFilter;
